import { ReactNode } from 'react';
import styles from './Page.module.scss';

interface PageProps {
  header?: ReactNode;
  nav?: ReactNode;
  children: ReactNode;
  fullWidth?: boolean;
}

export function Page({ header, nav, children, fullWidth = false }: PageProps) {
  return (
    <article
      className={`${styles.container} ${fullWidth ? styles['container--full-width'] : styles['container--breakpoints']}`}
    >
      {header && <div className={styles.header}>{header}</div>}

      {nav ? nav : null}

      {children}
    </article>
  );
}

export default Page;
